import { Pipe, PipeTransform } from "@angular/core";
import { Observable, map } from "rxjs";

import { SharedOptionsService } from "@shared/Services/shared-options.service";

@Pipe({
  name: "identificationType",
})
// eslint-disable-next-line @angular-eslint/use-pipe-transform-interface
export class IdentificationTypePipe implements PipeTransform {
  constructor(private sharedOptionsService: SharedOptionsService) {}

  public transform(identificationTypeId: string): Observable<string> {
    return this.sharedOptionsService.getIdentificationTypes().pipe(
      map((identificationTypes) => {
        return identificationTypes.find((type) => type.id === identificationTypeId)?.nombre || "";
      })
    );
  }
}
